import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import InputText from '../../../../common/components/ui/InputText';

const FieldOldPassword = () => {
  const intl = useIntl();
  const labelText = intl.formatMessage({
    id: 'settings-form-oldPassword',
    defaultMessage: 'Current password'
  });
  const placeholder = intl.formatMessage({
    id: 'default-placeholder',
    defaultMessage: 'Write here'
  });
  const [field, meta] = useField({name: 'oldPassword'});

  return (
    <InputText
      {...field}
      {...meta}
      variant={'full'}
      type={'password'}
      id={field.name}
      label={labelText}
      defaultValue={field.value}
      placeholder={placeholder}
    />
  );
};

export default FieldOldPassword;
